import { render, staticRenderFns } from "./postingharian.vue?vue&type=template&id=6fd67bb6&scoped=true&"
import script from "./postingharian.vue?vue&type=script&lang=js&"
export * from "./postingharian.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd67bb6",
  null
  
)

export default component.exports